import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=83b82444&scoped=true&lang=pug"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"
import style0 from "./ContactItem.vue?vue&type=style&index=0&id=83b82444&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b82444",
  null
  
)

export default component.exports